import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

export const getSystemLogs = async (page = 1, limit = 50, category = 'all', level = 'all', search = '', startDate = '', endDate = '') => {
  const params = { page, limit, category, level };
  if (search) params.search = search;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  return await axiosInstance({ role: ROLE.SUPER_ADMIN }).get('/admin/system-logs', { params });
};

export const getSystemLogStats = async () => {
  return await axiosInstance({ role: ROLE.SUPER_ADMIN }).get('/admin/system-logs/stats');
};

export const downloadSystemLogs = async (category = 'all', level = 'all', search = '', startDate = '', endDate = '') => {
  const params = { category, level };
  if (search) params.search = search;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  return await axiosInstance({ role: ROLE.SUPER_ADMIN }).get('/admin/system-logs/download', {
    params,
    responseType: 'blob',
  });
};
